var map = {
	"./fr-audi/legalTerms": 5230,
	"./fr-cupra/legalTerms": 74574,
	"./fr-seat/legalTerms": 83582,
	"./fr-skoda/legalTerms": 63581,
	"./fr-vw/legalTerms": 97660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99688;